// eslint-disable-next-line
import * as signalR from "@microsoft/signalr";
import { SendPrivateMessageDto } from "../types/PrivateChat";

class PrivateChatHubService {

    private connection: signalR.HubConnection | null = null;

    async start(token: string) {

        if (this.connection) {

            if (
                this.connection.state === signalR.HubConnectionState.Connected
            ) {
                return;
            }

            if (
                this.connection.state === signalR.HubConnectionState.Connecting ||
                this.connection.state === signalR.HubConnectionState.Reconnecting
            ) {
                return;
            }
        }
//https://api-real.priceworth.com:7443/api/
//https://localhost:7166/api/
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(
                "https://api-real.priceworth.com:7443/privatechatHub",
                {
                    accessTokenFactory: () => token
                }
            )
            .withAutomaticReconnect()
            .build();

        await this.connection.start();

        console.log("Private SignalR Connected");
    }

    async stop() {

        if (!this.connection)
            return;

        if (
            this.connection.state !== signalR.HubConnectionState.Disconnected
        ) {
            await this.connection.stop();
        }

        this.connection = null;
    }

    isConnected() {

        return (
            this.connection?.state ===
            signalR.HubConnectionState.Connected
        );
    }

    async sendMessage(
        dto: SendPrivateMessageDto
    ) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "SendMessage",
            dto
        );
    }

    async typing(
        conversationId: string
    ) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "Typing",
            conversationId
        );
    }

    async stopTyping(
        conversationId: string
    ) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "StopTyping",
            conversationId
        );
    }

    async markDelivered(
        messageId: string
    ) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "MarkDelivered",
            messageId
        );
    }

    async markRead(
        conversationId: string
    ) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "MarkAsRead",
            conversationId
        );
    }

    // ----------------------------
    // EVENTS
    // ----------------------------

    onReceiveMessage(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("ReceivePrivateMessage");

        this.connection.on(
            "ReceivePrivateMessage",
            callback
        );
    }

    onUserTyping(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("UserTyping");

        this.connection.on(
            "UserTyping",
            callback
        );
    }

    onUserStoppedTyping(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("UserStoppedTyping");

        this.connection.on(
            "UserStoppedTyping",
            callback
        );
    }

    onMessagesRead(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("MessagesRead");

        this.connection.on(
            "MessagesRead",
            callback
        );
    }

    onMessageDelivered(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("MessageDelivered");

        this.connection.on(
            "MessageDelivered",
            callback
        );
    }

    onUserOnline(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("UserOnline");

        this.connection.on(
            "UserOnline",
            callback
        );
    }

    onUserOffline(callback: any) {

        if (!this.connection)
            return;

        this.connection.off("UserOffline");

        this.connection.on(
            "UserOffline",
            callback
        );
    }
}
// eslint-disable-next-line
export default new PrivateChatHubService();